import { DialogActions } from "@mui/material";
import { Button } from "@/components/ui/Button";
import { FileDown, BetweenHorizonalStart } from "lucide-react";

interface BudgetActionsProps {
  hasChanges: boolean;
  onDiscard: () => void;
  onSave: () => void;
  onExport: () => void;
  onAddBudgetRow: () => void;
}

export const BudgetActions = ({
  hasChanges,
  onDiscard,
  onSave,
  onExport,
  onAddBudgetRow,
}: BudgetActionsProps) => {

  return (
    <DialogActions className="mt-4">
      <Button
        variant="outlined"
        onClick={onExport}
        startIcon={<FileDown className="h-4 w-4" />}
      >
        Export
      </Button>
      <Button
        variant="outlined"
        onClick={onAddBudgetRow}
        startIcon={<BetweenHorizonalStart className="h-4 w-4" />}
      >
        Add row
      </Button>
      <Button
        variant="outlined"
        onClick={onDiscard}
        disabled={!hasChanges}
      >
        Reset changes
      </Button>
      <Button
        variant="contained"
        onClick={onSave}
        disabled={!hasChanges}
      >
        Save changes
      </Button>
    </DialogActions>
  );
};